<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ "repository.sites.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab [label]="'repository.sites.tabs.sites' | translate">
        <div class="tab-content">
          <app-sites></app-sites>
        </div>
      </mat-tab>
      <mat-tab [label]="'repository.sites.tabs.groups' | translate">
        <div class="tab-content">
          <app-site-groups></app-site-groups>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
